export default __webpack_public_path__ + "static/assets/23896f34368e957ad6b87f653cb99fc0.png";